<span class="status-badge status-badge--{{ resolvedType }}">
  <span class="status-badge__label">{{ label | translate }}</span>
</span>
